<template>
  <b-container class="d-flex align-items-center justify-content-center">
    <div id="login-main" class="spnod-admin__form--main d-flex align-items-center flex-column">
      <h3 class="h3 mb-4">Login</h3>
      <LoginForm />
    </div>
  </b-container>
</template>

<script>
import LoginForm from '../../components/Forms/LoginForm'

export default {
  name: 'AdminLogin',
  components: { LoginForm }
}
</script>



// WEBPACK FOOTER //
// src/app/Pages/AdminAuth/AdminLogin.vue?2152d8ff